import { resolveAuthenticatedAppPath } from "@/lib/pwa-launch";
import { authService } from "./auth.service";

/** En cookie-only la sesión vive en HttpOnly; usar requireSessionClient(). */
export function isAuthenticated(): boolean {
  return false;
}

export async function requireSessionClient(): Promise<boolean> {
  const u = await authService.getCurrentUser();
  return Boolean(u);
}

export async function redirectIfAuthenticatedClient(): Promise<void> {
  if (typeof window === "undefined") return;
  const u = await authService.getCurrentUser();
  if (!u) return;
  window.location.href = resolveAuthenticatedAppPath(u.role);
}
